import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  mutation EscalateChat($id: ID!, $visitorEmail: String!) {
    escalateChat(id: $id, visitorEmail: $visitorEmail) {
      id
    }
  }
`);
